<template>
  <div>
    <v-row>
      <v-col cols='12'>
        <v-text-field
          label='First name'
          :rules='[rules.required]'
          v-model='value.first_name'
        ></v-text-field>
      </v-col>
      <v-col cols='12'>
        <v-text-field
          label='Last name'
          v-model='value.last_name'
        ></v-text-field>
      </v-col>
      <v-col cols='12'>
        <v-text-field
          label='Username'
          v-model='value.username'
          disabled
          hint='Cannot change'
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formRules from '@/mixins/formRules'

export default {
  name: 'profile-basics-form',
  mixins: [formRules],
  props: {
    value: {
      required: true
    }
  }
}
</script>
